import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsuarioEmpresaListarComponent } from './usuario-empresa-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: UsuarioEmpresaListarComponent}
  ])],
  exports: [RouterModule]
})
export class UsuarioEmpresaListarRoutingModule { }
